export default __webpack_public_path__ + "static/media/portfolio2.ae187bc4.jpg";